import createReactComponent from '../createReactComponent';
export default createReactComponent('flag-one', 'FlagOne', [["path",{"d":"m4.75 14 13.78-4.04c.96-.282.96-1.638 0-1.92L4.75 4m0 10V4m0 10v7m0-17V3","key":"svg-0"}]]);